export var getCurrentLiveStreamSlice = function (state) { return state.currentLiveStream; };
export var getWidgetSlice = function (state) { return state.widget; };
export var getAccountSlice = function (state) { return state.account; };
